import styled, { css } from 'styled-components'

export const Container = styled.div`
  margin-top: auto;
  position: relative;
  padding: ${props => props.theme.spacing.sp8};
  background-color: ${props => props.theme.colors.outline.surface};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.background.secondary};
  width: ${props => props.theme.size.XL};
  height: ${props => props.theme.size.L};
  overflow: hidden;
  transition:
    width 0.25s ease-in-out,
    height 0.25s ease-in-out;

  ${props =>
    props.expanded &&
    css`
      width: 232px;
      height: 112px;
    `}
`

export const IconRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${props => props.theme.size.M};
  opacity: 1;
  transition: opacity 0.12s ease 0.15s;

  ${props =>
    props.expanded &&
    css`
      opacity: 0;
      transition: opacity 0.1s ease 0s;
    `}
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ExpandedCard = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  opacity: 0;
  transition: opacity 0.12s ease 0s;

  ${props =>
    props.expanded &&
    css`
      opacity: 1;
      transition: opacity 0.2s ease 0.18s;
    `}
`

export const SupportLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  color: ${props => props.theme.colors.outline.default};
  text-decoration: underline;
  cursor: pointer;
`
